module.exports = __webpack_public_path__ + "images/social/logo-6cc0aa11.png";